import { IonButton, IonCard, IonCardContent } from "@ionic/react";
import WithNavigation from "../../hoc/with-navigation";
import useForm from "../../hooks/use-form";
import { required } from "../../utils/validators";
import InputForm from "../common/input-form";

import "./styles.css";

const CreateSystemForm = ({
	defaultState = undefined,
	submitLabel = "Crear",
	onSubmit,
}) => {
	const requiredValidator = () => (value: string) => ({
		valid: !!required(value),
	});

	const {
		valid,
		errors,
		formState: { state },
		handleUpdates,
		handleSubmit,
	} = useForm(
		{
			name: requiredValidator(),
		},
		{
			initialState: defaultState,
			validateOnChange: true,
		}
	);

	return (
		<div className="card-from">
			<IonCard class="card-container card-form-pix content-modal">
				<IonCardContent className="content-modal">
					<div className="card-content">
						<>
							<div className="card-from-input">
								<p className="card-from-input-label">Nombre del Sistema</p>
							</div>
							<InputForm
								id="name"
								value={state.name}
								onValueChange={handleUpdates("name")}
								error={undefined}
								disabled={false}
							/>
						</>
						<IonButton
							id="confirm-key-button"
							className="button-confirm"
							fill="clear"
							color="primary"
							onClick={handleSubmit(onSubmit)}
							disabled={!valid}
						>
							{submitLabel}
						</IonButton>
					</div>
				</IonCardContent>
			</IonCard>
		</div>
	);
};

export default CreateSystemForm;
